module.exports = __webpack_public_path__ + "img/service_web_solutions_5_2x.bcfee121.jpg";